<div class="container">
  <crm-tgbot-side-nav>
    <router-outlet></router-outlet>
  </crm-tgbot-side-nav>
</div>
